import { LegalEntity } from "@/services/legalEntity/schemas/legalEntity";

export type LegalEntityState = {
  entities: Map<string, LegalEntity>;
};

export const state: LegalEntityState = {
  entities: new Map<string, LegalEntity>(),
};
